import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

const DEFAULTS = {
  title: 'DonaApp — Dona productos reales a causas verificadas',
  description: 'Conecta con causas verificadas y dona productos reales — alimentos, ropa, materiales. Sin dinero de por medio.',
  image: 'https://donaapp.co/og-image.png',
  url: 'https://donaapp.co',
  type: 'website',
};

/**
 * Componente SEO reutilizable para meta tags dinámicos por página.
 * Usa react-helmet-async para inyectar/reemplazar meta tags en el <head>.
 */
export function SEO({ title, description, image, url, type }: SEOProps) {
  const t = title ? `${title} | DonaApp` : DEFAULTS.title;
  const d = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const u = url || DEFAULTS.url;
  const tp = type || DEFAULTS.type;

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />

      {/* Open Graph */}
      <meta property="og:type" content={tp} />
      <meta property="og:url" content={u} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="DonaApp" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
